import Letter from './modules/letter/letter.js';
import 'bootstrap/js/dist/popover';

// Extend jQuery library
$.fn.overflown = function () {
    let e = this[0];
    if (e != undefined) {
        return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
    }
};

$(document).ready(function () {
    window.letterTool = new Letter();
    letterTool.init();

    $('.wz-btn-add-to-cart-letter').click(function (e) {
        e.preventDefault();

        let self = $(this);
        let data = self.closest("form").serializeArray();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                items: [{
                    item_name: $('input[name=stencil]').val() === '0' ? 'Lettrage adhésif' : 'Pochoir à peindre',
                    price: Number($('.text-price:first').text().replace(',', '.')),
                    quantity: Number($('.quantity-field').val()),
                }]
            }
        });

        $.ajax({
            url: route('front.letter.add_cart'),
            method: 'POST',
            data: data,
            beforeSend: function () {
                $('body').addClass('loading');
            },
            success: function (response) {
                jQuery.noConflict();
                window.$(self.data('modal')).modal('show');
                jQuery('.cart-line-menu').html(response.html);
            },
            error: function(xhr, status) {
                if (status === 'abort') {
                    return;
                }

                let response = JSON.parse(xhr.responseText);

                if (response.errors) {
                    $('.module-letter-error > .alert')
                        .html(response.errors)
                        .slideDown();

                    $("html, body").animate({
                        scrollTop: $('.module-letter-error').offset().top
                    }, 300);
                }
            },
            complete: function() {
                $('body').removeClass('loading');
            }
        });
    });

    $(document).click(function(e) {
        if (0 === $(e.target).closest('#selector').length) {
            $('[data-toglle="collapse"]').addClass('collapsed');
            $('#selector .collapse').removeClass('show');
        }
    });

    $('#lettrageadhesif-information').popover({
        trigger: 'hover',
        html: true,
        container: 'body',
        placement: 'bottom',
        title: 'Qu\'est ce qu\'un lettrage adhésif',
        content: '- C\'est un ensemble de lettres découpées selon votre personnalisation dans un <strong>vinyle adhésif pleine masse</strong>. Epaisseur du film 64 microns.<br>' +
            '- Seules les lettres adhésives resteront collées sur votre support.<br>' +
            '- Le <strong>support siliconé</strong> sert à protéger vos lettres et le <strong>transfert</strong> à faciliter la pose du lettrage (voir vidéos de pose)<br>' +
            'Vinyle adhésif polymère "Avery 700" résistant aux intempéries et à l\'eau de mer.<br>' +
            '<strong>Durée minimum en extérieur</strong> pour le noir et le blanc 8 ans, les couleurs 7 ans, et 5 ans pour les couleurs métal.' +
            '<img width="350" class="img-fluid" src="/img/lettrage.png" alt="lettrage"/>'
    });
});

